/* MrSneaker custom product page interactions. Lightweight, no dependencies. */
(function () {
  'use strict';

  function initHero(hero) {
    if (!hero || hero.dataset.mrsInit === '1') return;
    hero.dataset.mrsInit = '1';

    var idInput = hero.querySelector('.mrs-variant-id');
    var chips = Array.prototype.slice.call(hero.querySelectorAll('.mrs-chip'));
    var buyBtn = hero.querySelector('.mrs-buy');
    var buyPriceEls = hero.querySelectorAll('[data-mrs-buy-price]');
    var mainPriceEl = hero.querySelector('[data-mrs-main-price]');

    // Region toggle (UK / EU / US)
    var regionBtns = Array.prototype.slice.call(hero.querySelectorAll('.mrs-region__btn'));
    var currentRegion = 'uk';

    // Count UK values so duplicates can be disambiguated with the EU size.
    var ukCounts = {};
    chips.forEach(function (c) { var u = c.getAttribute('data-uk') || ''; ukCounts[u] = (ukCounts[u] || 0) + 1; });

    // Custom dropdown (mobile)
    var customSel = hero.querySelector('[data-mrs-select]');
    var selBtn = customSel ? customSel.querySelector('.mrs-select__btn') : null;
    var selList = customSel ? customSel.querySelector('.mrs-select__list') : null;
    var selLabel = customSel ? customSel.querySelector('.mrs-select__label') : null;
    var selOpts = customSel ? Array.prototype.slice.call(customSel.querySelectorAll('.mrs-select__opt')) : [];

    function displayVal(el) {
      var v = el.getAttribute('data-' + currentRegion) || el.getAttribute('data-uk') || '';
      if (currentRegion === 'uk' && ukCounts[v] > 1) {
        var eu = el.getAttribute('data-eu');
        if (eu) v = v + ' (' + eu + ')';
      }
      return v;
    }

    function closeSel() { if (selList) { selList.hidden = true; selBtn.setAttribute('aria-expanded', 'false'); customSel.classList.remove('is-open'); } }
    function openSel() { if (selList) { selList.hidden = false; selBtn.setAttribute('aria-expanded', 'true'); customSel.classList.add('is-open'); } }

    function selectChip(chip) {
      if (!chip || chip.getAttribute('aria-disabled') === 'true') return;
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      var vid = chip.getAttribute('data-variant-id');
      var priceText = chip.getAttribute('data-price') || '';
      var available = chip.getAttribute('data-available') === 'true';
      if (idInput) idInput.value = vid;
      if (mainPriceEl && priceText) mainPriceEl.textContent = priceText;
      buyPriceEls.forEach(function (el) { if (priceText) el.textContent = priceText; });
      if (buyBtn) {
        buyBtn.disabled = !available;
        if (available && buyBtn.dataset.showPrice === 'true' && priceText) {
          buyBtn.textContent = (buyBtn.dataset.addText || 'Buy Now') + '  -  ' + priceText;
        } else if (available) {
          buyBtn.textContent = (buyBtn.dataset.addText || 'Buy Now');
        } else {
          buyBtn.textContent = (buyBtn.dataset.soldText || 'Sold out');
        }
      }
      if (selOpts.length) {
        selOpts.forEach(function (o) { o.setAttribute('aria-selected', o.getAttribute('data-variant-id') === vid ? 'true' : 'false'); });
        var so = selOpts.filter(function (o) { return o.getAttribute('data-variant-id') === vid; })[0];
        if (so && selLabel) selLabel.textContent = so.getAttribute('data-label') || so.textContent.trim();
      }
      document.dispatchEvent(new CustomEvent('mrs:variant:change', {
        detail: { id: vid, price: priceText, size: displayVal(chip), available: available }
      }));
    }

    chips.forEach(function (chip) { chip.addEventListener('click', function () { selectChip(chip); }); });

    // Apply the selected region to every size label
    function applyRegion() {
      chips.forEach(function (c) {
        var s = c.querySelector('.mrs-chip__uk');
        if (s) s.textContent = displayVal(c);
      });
      selOpts.forEach(function (o) {
        var sold = o.getAttribute('data-available') !== 'true' ? ' — Sold out' : '';
        var price = o.getAttribute('data-price') || '';
        var label = displayVal(o) + sold + (price ? ' · ' + price : '');
        o.setAttribute('data-label', label);
        o.textContent = label;
      });
      var cur = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; })[0] || chips[0];
      if (cur) selectChip(cur);
    }

    regionBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        currentRegion = b.getAttribute('data-region') || 'uk';
        regionBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        applyRegion();
      });
    });

    if (selBtn) {
      selBtn.addEventListener('click', function (e) { e.stopPropagation(); if (selList.hidden) openSel(); else closeSel(); });
      selOpts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          if (opt.getAttribute('data-available') !== 'true') return;
          var match = chips.filter(function (c) { return c.getAttribute('data-variant-id') === opt.getAttribute('data-variant-id'); })[0];
          if (match) selectChip(match);
          closeSel();
        });
      });
      document.addEventListener('click', function (e) { if (customSel && !customSel.contains(e.target)) closeSel(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSel(); });
    }

    var condBtns = hero.querySelectorAll('.mrs-cond__btn');
    condBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        condBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      });
    });

    hero.querySelectorAll('[data-mrs-wishlist]').forEach(function (w) {
      w.addEventListener('click', function () {
        var on = w.getAttribute('aria-pressed') === 'true';
        w.setAttribute('aria-pressed', on ? 'false' : 'true');
      });
    });

    var main = hero.querySelector('[data-mrs-main-img]');
    hero.querySelectorAll('.mrs-gallery__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-full');
        var alt = t.getAttribute('data-alt') || '';
        if (main && src) {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = src;
          main.alt = alt;
        }
        hero.querySelectorAll('.mrs-gallery__thumb').forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      });
    });

    applyRegion();
  }

  function initSticky() {
    var bar = document.querySelector('.mrs-sticky');
    if (!bar || bar.dataset.mrsInit === '1') return;
    bar.dataset.mrsInit = '1';
    var hero = document.querySelector('[data-mrs-hero]');
    var anchor = document.querySelector('.mrs-buy');
    var priceEl = bar.querySelector('[data-mrs-sticky-price]');
    var sizeEl = bar.querySelector('[data-mrs-sticky-size]');
    var btn = bar.querySelector('.mrs-sticky__btn');

    document.addEventListener('mrs:variant:change', function (e) {
      if (priceEl && e.detail.price) priceEl.textContent = e.detail.price;
      if (sizeEl && e.detail.size) sizeEl.textContent = e.detail.size;
      if (btn) btn.disabled = !e.detail.available;
    });

    if (btn) {
      btn.addEventListener('click', function () {
        var form = hero ? hero.querySelector('.mrs-form') : document.querySelector('.mrs-form');
        if (!form) return;
        var submit = form.querySelector('.mrs-buy');
        if (form.requestSubmit) { form.requestSubmit(submit); } else { form.submit(); }
      });
    }

    if (anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { bar.classList.remove('is-visible'); }
          else if (entry.boundingClientRect.top < 0) { bar.classList.add('is-visible'); }
          else { bar.classList.remove('is-visible'); }
        });
      }, { threshold: 0 });
      io.observe(anchor);
    } else {
      bar.classList.add('is-visible');
    }
  }

  function initCarousels() {
    document.querySelectorAll('[data-mrs-carousel]').forEach(function (root) {
      if (root.dataset.mrsInit === '1') return; root.dataset.mrsInit = '1';
      var track = root.querySelector('.mrs-rel__track');
      var prev = root.querySelector('[data-mrs-prev]');
      var next = root.querySelector('[data-mrs-next]');
      if (!track) return;
      function step() { var c = track.querySelector('.mrs-rel__card'); return c ? c.offsetWidth + 18 : 280; }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  function boot() {
    document.querySelectorAll('[data-mrs-hero]').forEach(initHero);
    initSticky();
    initCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
